import { render, staticRenderFns } from "./JewelryList.vue?vue&type=template&id=3212c95a&scoped=true"
import script from "./JewelryList.vue?vue&type=script&lang=js"
export * from "./JewelryList.vue?vue&type=script&lang=js"
import style0 from "./JewelryList.vue?vue&type=style&index=0&id=3212c95a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3212c95a",
  null
  
)

export default component.exports